import type { ScaleSelectorProps, WaterScaleData } from "@qendo/profile/journal";
import { ScaleType, WaterVolume } from "@qendo/trackables";
import { useEffect, useState } from "react";
import { FieldGroup } from "~/components/form/FieldGroup";
import { NumberCombo } from "~/components/form/NumberCombo";
import type { OptionalNumeric } from "~/util/string";

export type WaterSelectorProps = ScaleSelectorProps<ScaleType.water>;

export const WaterSelector = ({ value, onUpdateScale, disabled, error, zIndex }: WaterSelectorProps) => {
    const [scale, setScale] = useState<OptionalNumeric>(value.value);
    const [volume, setVolume] = useState<WaterVolume>(value.volume);

    // biome-ignore lint/correctness/useExhaustiveDependencies(value.value): upstream
    // biome-ignore lint/correctness/useExhaustiveDependencies(value.volume): upstream
    // biome-ignore lint/correctness/useExhaustiveDependencies(onUpdateScale): setter
    useEffect(() => {
        const payload = {
            type: ScaleType.water,
            value: scale,
            volume: volume,
        } as WaterScaleData;

        if (payload.value !== value.value || payload.volume !== value.volume) {
            onUpdateScale(payload);
        }
    }, [scale, volume]);

    return (
        <FieldGroup zIndex={zIndex}>
            <NumberCombo<WaterVolume>
                label="Water intake"
                number={scale}
                setNumber={setScale}
                combo={volume}
                setCombo={setVolume}
                disabled={disabled}
                error={error}
                optional
                comboProps={{
                    items: Object.values(WaterVolume),
                    label: "Volume",
                }}
            />
        </FieldGroup>
    );
};
